module.exports = __webpack_public_path__ + "img/Res_Mus_fkl.f6a196dc.jpg";